import { enUS, es, it, pt, de, fr, ru } from 'date-fns/locale'

export function mapI18nToDateFnsLocale(i18nLocale) {
	switch (i18nLocale) {
		case 'en':
			return enUS
		case 'es':
			return es
		case 'it':
			return it
		case 'pt':
			return pt
		case 'de':
			return de
		case 'fr':
			return fr
		case 'ru':
			return ru
		default:
			return enUS
	}
}

export function mapI18nToDateFnsFormat(i18nLocale) {
	switch (i18nLocale) {
		case 'en':
			return 'MMMM d'
		case 'es':
			return "d 'de' MMMM"
		case 'it':
			return 'd MMMM'
		case 'pt':
			return "d 'de' MMMM"
		case 'de':
			return 'do MMMM'
		case 'fr':
			return 'd MMMM'
		case 'ru':
			return 'd MMMM'
		default:
			return 'MMMM d'
	}
}
